import { BASEURL } from "../BaseUrl";

/**
 * Fetches a list of projects from the Benchling API.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getPostgresSchemas = async (axios, domainName) => {
  return await axios.get(`${BASEURL}/database/postgres/schemas`, {
    params: {
      domainName: domainName,
    },
  });
};

/**
 * Fetches Postgres Tables based on the Postgres Schemas.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} schema - The date parameter to filter tables.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getPostgresTables = async (axios, schema, domainName) => {
  return await axios.get(`${BASEURL}/database/postgres/tables`, {
    params: {
      schemaName: schema,
      domainName: domainName,
    },
  });
};

const getPostgresColumns = async (axios, schema, table, domainName) => {
  return await axios.get(`${BASEURL}/database/postgres/columns`, {
    params: {
      schemaName: schema,
      tableName: table,
      domainName: domainName,
    },
  });
};

export const PostgresApi = {
  getPostgresSchemas,
  getPostgresTables,
  getPostgresColumns,
};
